$(document).ready(function(e) {
    /* ====================  Slider ====================== */
    $('.home-slider').slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        slide: 'li',
        pauseOnHover:false 
    });
  
      $('.delivery-slider').slick({
        dots: false,
        pauseOnHover:false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        slide: 'li',
        responsive: [{
                breakpoint: 1700,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
        ]

    });
  
        $('.merch-slider').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay: true,
        autoplaySpeed: 2000,
        slide: 'li',
          responsive: [{
                breakpoint: 1700,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
           

        ]
    });

  
        $('.supermarket-slider').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover:false,
        autoplaySpeed: 2000,
        slide: 'li',
          responsive: [{
                breakpoint: 1700,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
           

        ]
    });


    $('.home-logo-slider,.our-client-slider').slick({
        dots: false,
        arrows: false,
        slidesToShow: 10,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        slide: 'li',
        responsive: [{
                breakpoint: 1700,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
           

        ]
    });
                     
                     
    $('.testimonial-slider').slick({
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        slide: 'li',
    });
    $('.related-product-slider').slick({
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        slide: 'li',
        responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
        ]
    });
    $('.product-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: false,
        asNavFor: '.product-nav'
    });

    $('.product-nav').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.product-for',
        dots: true,
        arrows: true,
        infinite: false,
        focusOnSelect: true,
      	responsive: [        
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }        
      ]
    });

    /* ====================  Magnific Popup ====================== */

    $('.about-gallery ul li').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
            enabled: true
        }
    });


    /* ====================  Equilizer ====================== */

    equalheight = function(container) {

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;
        $(container).each(function() {

            $el = $(this);
            $($el).height('auto')
            topPostion = $el.position().top;

            if (currentRowStart != topPostion) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPostion;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            }
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
        });
    }

    $(window).load(function() {
        equalheight('.equal-height');
    });


    $(window).resize(function() {
        equalheight('.equal-height');
    });

    /* =========== Sticky ============ */
  
    $(document).scroll(function() {
      var navHeight = $("header").innerHeight(); 
      var y = $(document).scrollTop(), 
          header = $("header"); 
      if(y >= navHeight){
        if( parseInt($(window).height()+navHeight + 80) < parseInt($('html').height()) ){
          header.addClass('stickytop'); 
        }
      } 
      else {
        header.removeClass('stickytop');
      } 
      
      if ($(this).scrollTop() > 150) {
        $('.home-header').addClass('stickytop');
      } else {
        $('.home-header').removeClass('stickytop');
      }

    });
  /*
    $(window).scroll(function() {
        if ($(this).scrollTop() > 1) {
            $('header').addClass('stickytop');
        } else {
            $('header').removeClass('stickytop');
        }
        if ($(this).scrollTop() > 150) {
            $('.home-header').addClass('stickytop');
        } else {
            $('.home-header').removeClass('stickytop');
        }

    });
  */
    /*------------ Product Quantity Count ---------------*/
	
   /* $('.quantity-counter .minus-box').on('click', function() {
		var count = $(this).siblings(".QuantityInput");
		var val = parseInt(count.val());
        if (val > 1){
              count.val(val - 1);
        }
	});
	$('.quantity-counter .plus-box').on('click', function() {
		var count = $(this).siblings(".QuantityInput");
		var val = parseInt(count.val());
		count.val(val + 1);
	});
/*
	$('.variable-counter .minus-box').on('click', function() {
		var count = $(this).siblings(".QuantityInput");
		var val = parseInt(count.val());
        if (val > 0){
              count.val(val - 1);
        }
	});
	$('.variable-counter .plus-box').on('click', function() {
		var count = $(this).siblings(".QuantityInput");
		var val = parseInt(count.val());
		count.val(val + 1);
	});
*/
    /*-------------- Main Menu --------------*/
  
    $('.navbar-toggler').click(function() {
        var $t = $('.post-with-toc');

        if ($t.is(':visible')) {

            $(".navbar-toggler").removeClass("cross-icon");
            $(".navbar-toggler").addClass("toggle-menu");
            $("body").removeClass("body-class");
			$(".get-quote-close").hide();
			$(".get-quote-open").show();


        } else {

            $(".navbar-toggler").removeClass("toggle-menu");
            $(".navbar-toggler").addClass("cross-icon");
            $("body").addClass("body-class");
			$(".get-quote-close").show();
			$(".get-quote-open").hide();

        }
    });

    $('#toggle').on('click', function() {
        $(this).parents('.post').toggleClass('post-with-toc');
    });
  
    $('.search_btn').on('click', function() {
      $('.search_box').show();
    });

    $('.search_close').on('click', function() {
      $('.search_box').hide();
    });
  

    /*--------------      Filter Menu      --------------*/
    if ($(window).width() <= 991) {

        function setHeight() {
            windowHeight = $(window).innerHeight();
            $('.filter-menu-section').css('height', windowHeight);
        };
        setHeight();

        $(window).resize(function() {
            setHeight();
        });
    }
    $('.get-quote-mobile a.filter-li').click(function(e) {
        $('.filter-menu-section').toggle();

    });
    $('.toggle-menu').click(function(e) {
        $('.filter-menu-section').hide();
    });
  
    $('.see-more').click(function(e) {
        $('.see-more').hide();
        $('.text-mobile').hide();
        $('.text-desktop').show();
      
        $('.get-quote-btn.get-popup').show();
       $('.get-quote-btn.get-popup').css('display', 'block');

    });


  /*----------- Get Quote Popup --------------*/
    
    $('.get-quote-section a.get-popup,.get-quote-mobile a.get-popup,.get-popup').click(function(e) {
      $("#getquote-popup").modal('show');
    });

  /*----------- Preloader ---------------*/


  $(window).load(function () {
    $("#status").fadeOut(1000);
    $("#preloader").delay(600).fadeOut("slow");
  });

  /*--------------      Slider Image      --------------*/
  
  function sliderHeight() {
    jQuery('.home-slider .slider_img, .banner-section figure.bg-img img').each(function() {

      var el = $(this),
          src = el.attr('src'),
          parent = el.parent(),
          height = $(window).innerHeight();

      parent.css({
        'background': 'url(' + src + ')',
        'background-size': 'cover',
        'background-position': 'center',
        'height': height
      });

      el.hide();
    });
  };

  sliderHeight();

  $(window).resize(function() {
    sliderHeight();
  });
  
  $(window).load(function() {
    sliderHeight();
  });
  
  /*--------------       Slider Video Full Screen  --------------*/
  
  var windowHeight = $(window).innerHeight();
  $('.embed-responsive').css('padding-bottom',windowHeight);

  $(window).resize(function() {
    var windowHeight = $(window).innerHeight();
    $('.embed-responsive').css('padding-bottom',windowHeight);
  });
  
  /*--------------       Lookbook Gallery  --------------*/

  function galleryHeight() {
    jQuery('.gallery-img').each(function() {

      var el = $(this),
          src = el.attr('src'),
          parent = el.parent(),
          height = parent.width();

      parent.css({
        'background-image': 'url(' + src + ')',
        'background-size': 'cover',
        'background-position': 'center',
        'height': height
      });

      //console.log(height);
      el.hide();
    });
  }
  galleryHeight();

  $(window).resize(function() {
    galleryHeight();
  });
    
  $(window).load(function() {
    galleryHeight();
  });
  
  /*--------------        Min Height   --------------*/
  
  function window_height(){
    var _height = $(window).height() - $('footer').height() - $('header').height(); 
    $('#MainContent').css('min-height',_height);
  }
  
  $(window).resize(function() {
    window_height();
  });
  
  $(window).load(function() {
    window_height();
  });
  
  /*--------------        Shop Loadmore   --------------*/

  if ( $('ul.shop-list li').size() == 0 ){
    $('#loadMore').hide();          
  }

  var shop_sizeli = $("ul.shop-list li").size();
  var shop_x = 20;
  $('ul.shop-list li:lt(' + shop_x + ')').show();
  $('#loadMore').click(function() {
    shop_x = (shop_x + 8 <= shop_sizeli) ? shop_x + 8 : shop_sizeli;
    $('ul.shop-list li:lt(' + shop_x + ')').show();

    if (shop_x == shop_sizeli) {
      $('#loadMore').hide();
    }
    return false;
  });

  if( $('ul.shop-list li').size() >= 19 ){
    $('#loadMore').show();
  }
  else{
    $('#loadMore').hide();          
  }
  

  /* Filter Active */

  var path = location.pathname.substring(1);
  if (path) { 
    $('.filter-menu ul li a[href$="' + path + '"]').parent().addClass('selected');
  }; 
  
  

/*--------------  Succes Stories Page   --------------*/

  
   $('.success-stories-slider-first-list').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover:false,
        autoplaySpeed: 2000,
        slide: 'li',
          responsive: [{
                breakpoint: 2400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1230,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
           

        ]
    });
  
   $('.success-stories-slider-second-list').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover:false,
        autoplaySpeed: 2000,
        slide: 'li',
          responsive: [{
                breakpoint: 2400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1230,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
           

        ]
    });
  
  
  $('.success-stories-slider-third-list').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover:false,
        autoplaySpeed: 2000,
        slide: 'li',
          responsive: [{
                breakpoint: 2400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1230,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
           

        ]
    });
                       
    $('.success-stories-slider-four-list').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover:false,
        autoplaySpeed: 2000,
        slide: 'li',
          responsive: [{
                breakpoint: 2400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1230,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
           

        ]
    });
                       
                       
                       
   $('.industry-specific-slider').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover:false,
        autoplaySpeed: 2000,
        slide: 'li',
          responsive: [{
                breakpoint: 2400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
           

        ]
    });
  

   /*--------------  Client Specific Page  --------------*/
 
        window.addEventListener('load', (event) => {                       
	    var top_nav_height = $("#client-specific-banner-image").height();
    	$(".client-specific-banner-title").css("height", top_nav_height);
    });           
});



















